import styled from 'styled-components/macro';

export const FlexRowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
